/**
 * @param type year：获取当前年(2019)/ month：获取当前月日期（2019-03）/默认获取当天（2019-03-28）
 * 格式YYYY-MM-DD
 */
export const getNowFormatDate = function (pattern) {
    var date = new Date();
    return formatDate(date, pattern);
}
/**
 * 获取当前时间
 */
export const getNowTime = function () {
    var now = new Date();
    var h = now.getHours() < 10 ? '0' + now.getHours() : now.getHours();
    var m = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes();
    var s = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds();
    return h + ':' + m + ':' + s;
}


/**
 * @param pattern pyear:获取年格式(YYYY) ;pmonth:获取年月格式(YYYY-MM) ;pday:获取年月日格式(YYYYY-MM-DD)
 * @param type year：获取去年(2018-03-28)/ month：获取上个月（2019-02-28）/默认获取上一天（2019-03-27）
 */
export const getLastDay = function (type, pattern) {
    var date = new Date();
    var yester;
    switch (type) {
        case 'year':
            // yester = new Date(date - 1000 * 60 * 60 * 24*30*365);
            date.setFullYear(date.getFullYear() - 1);
            yester = date;
            break;
        case 'month':
            yester = new Date(date - 1000 * 60 * 60 * 24 * 30);
            break;
        default:
            yester = new Date(date - 1000 * 60 * 60 * 24);
            break;
    }
    return formatDate(yester, pattern);
}

export const getFirstDay = function (type, pattern) {
    var date = new Date();
    var yester;
    switch (type) {
        case 'year':
            // yester = new Date(date - 1000 * 60 * 60 * 24*30*365);
            date.setFullYear(date.getFullYear());
            yester = date;
            break;
        case 'month':
            yester = new Date(date - 1000 * 60 * 60 * 24 * 30*7);
            break;
        default:
            yester = new Date(date - 1000 * 60 * 60 * 24*31);
            break;
    }
    return formatDate(yester, pattern);
}




export const formatDate = function (date, pattern) {
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate = '';
    switch (pattern) {
        case 'year':
            currentdate = year;
            break;
        case 'month':
            currentdate = year + seperator1 + month
            break;

        default:
            currentdate = year + seperator1 + month + seperator1 + strDate;
            break;
    }
    return currentdate;
};